//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { scrollTo } from "../../../src/utils/scrollTo"

export default {
  name: "VocPagination",
  props: {
    pagerCount: {
      type: Number,
      default: 7
    },
    // 默认带有背景色
    background: {
      type: Boolean,
      default: true
    },
    layout: {
      type: String,
      // 前一页 分页 后一页 每页数量 跳转至
      default: "prev, pager, next, sizes, jumper"
    },
    // 当前页码
    currentPage: {
      type: Number,
      default: 1
    },
    // 每页显示条数
    pageSize: {
      type: Number,
      default: 10
    },
    // 记录总条数
    total: {
      type: Number,
      required: true
    },
    // 翻页之后跳转至指定 dom 锚点或者页面顶部
    autoScroll: {
      type: Boolean,
      default: true
    },
    // 获取指定 dom 元素的 scrollTop
    archor: {
      type: String,
      default: ".el-main"
    }
  },
  computed: {
    archorEl() {
      return document.querySelector(this.archor)
    }
  },
  methods: {
    // 当前页变化触发
    onCurrentPageChanged(currentPage) {
      this.$emit("voc-pagination-current-page-changed", currentPage)
      if (this.autoScroll) {
        scrollTo(0, 800, this.archorEl)
      }
    },
    // pageSize (每页显示条数) 变化后触发
    onPageSizeChanged(pageSize) {
      this.$emit("voc-pagination-page-size-changed", pageSize)
      if (this.autoScroll) {
        scrollTo(0, 800, this.archorEl)
      }
    }
  }
}
